// extracted by mini-css-extract-plugin
module.exports = {"outro":"outro-module--outro--5mzXt","certifications":"outro-module--certifications--2aHcj"};